<template>
	<article class="dad u__text-center">
		<draggable
			v-model="images"
			v-bind="options"
			:class="[
				{
					'is-updating': isUpdating
				},
				'content'
			]"
		>
			<template v-for="(image, index) in images">
				<div
					v-if="isVideo(image.name)"
					:class="['photo', 'filter', { firstbigpic: index === 0 }]"
					:key="image.id"
				>
					<video muted loop playsinline autoplay :controls="false" :preload="true">
						<source :src="$getImgUrl(image.name)" type="video/mp4" />
					</video>

					<router-link :to="`/edit-movies/${image.id}`" class="link-edit">
						{{ image.order }}
					</router-link>
				</div>

				<div
					v-else
					:class="['photo', 'filter', { firstbigpic: index === 0 }]"
					:style="[
						{ background: 'url(' + $getImgUrl(image.name) + ')' },
						{ 'background-size': 'cover' },
						{ 'background-repeat': 'no-repeat' }
					]"
					:key="image.id"
				>
					<router-link :to="`/edit-movies/${image.id}`" class="link-edit">
						{{ image.order }}
					</router-link>
				</div>
			</template>
		</draggable>
		<div class="photo filter">
			<img :src="$getImgUrl('dodaj.jpg')" class="image" />
			<router-link to="/edit-movies/add" class="link-edit">
				dodaj
			</router-link>
		</div>
	</article>
</template>
<script>
import Draggable from 'vuedraggable'

export default {
	components: {
		Draggable
	},
	data() {
		return {
			isUpdating: false,
			options: {
				animation: 200,
				disabled: this.isUpdating,
				ghostClass: 'drag-ghost',
				forceFallback: true,
				group: 'images'
			}
		}
	},
	computed: {
		images: {
			get: ({ $store }) =>
				$store.getters['image/data'].filter((item) => item.filter !== 'project'),
			async set(value) {
				this.isUpdating = true

				const toBeUpdated = []
				const ordered = value.map((item, index) => {
					const sameIndex = this.$store.getters['image/data'].findIndex(
						(i) => i.id === item.id
					)
					if (+this.$store.getters['image/data'][sameIndex].order !== index) {
						item.order = index
						toBeUpdated.push(item)
					}
					return item
				})
				this.$store.dispatch('image/updateAll', ordered)
				const promises = []

				toBeUpdated.forEach((item) => {
					const formData = new FormData()
					formData.append('image', null)
					formData.append('filter', item.filter)
					formData.append('isDownText', item.isDownText)
					formData.append('link', item.link)
					formData.append('order', item.order)
					formData.append('projectId', '')
					formData.append('text1', item.text1)
					formData.append('text2', item.text2)
					formData.append('upText', item.upText)
					formData.append('id', item.id)
					promises.push(
						this.$store.dispatch('image/update', { id: item.id, formData })
					)
				})
				await Promise.all(promises)

				this.$alertBox({
					labels: {
						text: this.$t('alerts.saved_changes')
					},
					type: 'success'
				})

				this.isUpdating = false
			}
		}
	},
	methods: {
		isVideo: (name) =>
			name.split('.')[1] === 'mp4' || name.split('.')[1] === 'mov' ? true : false
	}
}
</script>
